import media from 'style-utils/media-queries';
import { css } from 'styled-components';

// https://www.figma.com/design/AaT6MvmrhxgPLQjWt1qGDj/%F0%9F%96%A5%EF%B8%8F-DS-WEB-GLOBAL?node-id=8424-289495&p=f&m=dev

export const displayD1 = css`
  font-family: var(--secondary-font-family);
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;

  ${media.desktop`
    font-size: 42px;
    line-height: 48px;
    `}
`;

export const displayD2 = css`
  font-family: var(--secondary-font-family);
  font-size: 24px;
  font-weight: 800;
  line-height: 28px;

  ${media.desktop`
    font-size: 28px;
    line-height: 32px;
    `}
`;

export const displayH1 = css`
  font-family: var(--secondary-font-family);
  font-size: 20px;
  font-weight: 800;
  line-height: 24px;

  ${media.desktop`
    font-size: 24px;
    line-height: 28px; 
    `}
`;

export const displayH2 = css`
  font-family: var(--secondary-font-family);
  font-size: 20px;
  font-weight: 800;
  line-height: 24px;
`;

export const displayH3 = css`
  font-family: var(--secondary-font-family);
  font-size: 16px;
  font-weight: 800;
  line-height: 18px;

  ${media.desktop`
    font-size: 18px;
    line-height: 20px; 
    `}
`;

export const bodyLead = css`
  font-family: var(--primary-font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  ${media.desktop`
    font-size: 16px;
    `}
`;

export const bodyLeadBold = css`
  ${bodyLead}
  font-weight: 700;
`;

export const body = css`
  font-family: var(--primary-font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

export const bodyCaption = css`
  font-family: var(--primary-font-family);
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
`;

export const bodyCaptionBold = css`
  ${bodyCaption}
  font-weight: 700;
`;

export const bodyMicroCaption = css`
  font-family: var(--primary-font-family);
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
`;
